import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ModalEdit: false,
    rwpendidikan: {
      id: '',
      pendidikan: {
        id: '',
        tk: {
          id: 0,
          nama: ''
        },
        gelar: {
          depan: null,
          belakang: null
        }
      },
      namaSekolah: '',
      lokasiSekolah: '',
      tahunLulus: '',
      nomorIjasah: '',
      namaKepalaSekolah: '',
      tglLulus: ''
    }
  },

  mutations: {
    toggleModal(state, value) {
      state.ModalEdit = value
    },
    editModal(state, value) {
      state.rwpendidikan = value
    },
    editDatautama(state, value) {
      state.dataUtama = value
    }
  }
})
